import BoxWithBullets from './_components/BoxWithBullets/index.ts';

const components = {
  a1: BoxWithBullets,
} as const;

export type HeaderSectionProps = {
  variant?: keyof typeof components;
};

export const HeaderSection: React.FC<HeaderSectionProps> = ({ variant = 'a1' }) => {
  let valid = false;
  if (components[variant]) {
    valid = true;
  }
  const Component = valid ? components[variant] : components.a1;

  return <Component />;
};

export default HeaderSection;
